import React from 'react';
import WhatsAppLogo from '../assets/WhatsApp_logo.svg';

const WHATSAPP_HREF = 'https://wa.me/8801840001034';

const WhatsAppButton = () => (
  <a
    href={WHATSAPP_HREF}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    title="Chat with us on WhatsApp"
    className="fixed right-4 bottom-28 md:right-6 md:bottom-6 z-30 flex items-center justify-center w-14 h-14 rounded-full bg-white shadow-lg hover:scale-105 active:scale-95 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#25D366]"
  >
    <img src={WhatsAppLogo} alt="WhatsApp" className="w-10 h-10" />
  </a>
);

export default WhatsAppButton;
